import { render, staticRenderFns } from "./calledsTable.vue?vue&type=template&id=7cb6064e&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./calledsTable.vue?vue&type=style&index=0&id=7cb6064e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb6064e",
  null
  
)

export default component.exports